export { default as TableHeader } from './TableHeader';
export { default as Table } from './Table';
export { default } from './Table';



// WEBPACK FOOTER //
// ./src/DataTable/index.js